import { render, staticRenderFns } from "./BetPerResultClashes.vue?vue&type=template&id=0f6489aa&scoped=true&"
import script from "./BetPerResultClashes.vue?vue&type=script&lang=js&"
export * from "./BetPerResultClashes.vue?vue&type=script&lang=js&"
import style0 from "./BetPerResultClashes.vue?vue&type=style&index=0&id=0f6489aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6489aa",
  null
  
)

export default component.exports